import { getAuth, connectAuthEmulator } from 'firebase/auth';
import app from './firebaseApp';

export const auth = getAuth(app);

if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099');
}